import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=20e98b4e&scoped=true"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"
import style0 from "./Text.vue?vue&type=style&index=0&id=20e98b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e98b4e",
  null
  
)

export default component.exports